// Module
var code = `<div>
    <div class="cluster-dashboard-item-header">
        <h3> <i class="icon-processor"></i> <span>CPU</span></h3>
        <button class="btn btn-warning btn-sm" data-bind="click: remove" title="Remove widget from board">
            <i class="icon-trash"></i>
        </button>
        <button class="btn btn-default btn-sm" data-bind="click: toggleFullscreen">
            <i data-bind="css: { 'icon-fullscreen': !fullscreen(), 'icon-exit-fullscreen': fullscreen },
                          attr: { title: fullscreen() ? 'Minimize widget' : 'Maximize widget' }"></i>
        </button>
    </div>
    <div class="property-container property-collapse">
        <h4>RavenDB CPU usage</h4>
        <div class="property">
            <div class="flex-horizontal">
                <div class="nodes-container" data-bind="foreach: nodeStats">
                    <div data-bind="attr: { class: 'nodes-item node-' + tag } ">
                        <div class="nodes-item-header" data-bind="css: { 'no-data': !currentItem(), 'spinner': spinner }">
                            <div class="node-label" data-bind="text: tag"></div>
                            <div class="node-value">
                                <span data-bind="text: processCpuUsageFormatted"></span>
                                <span class="supplementary-info" data-bind="text: ravendbCoresInfo"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="graph-container ravendb-line-chart">
            </div>
        </div>
    </div>
    <div class="property-container property-collapse">
        <h4>Machine CPU usage</h4>
        <div class="property">
            <div class="flex-horizontal">
                <div class="nodes-container" data-bind="foreach: nodeStats">
                    <div data-bind="attr: { class: 'nodes-item node-' + tag } ">
                        <div class="nodes-item-header" data-bind="css: { 'no-data': !currentItem(), 'spinner': spinner }">
                            <div class="node-label" data-bind="text: tag"></div>
                            <div class="node-value">
                                <span data-bind="text: machineCpuUsageFormatted"></span>
                                <span class="supplementary-info" data-bind="text: machineCoresInfo"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="graph-container machine-line-chart">
            </div>
        </div>
    </div>
</div>
`;
// Exports
export default code;